module.exports = __webpack_public_path__ + "static/img/UL.b859dad2.png";